import { Instagram, Youtube, Facebook } from 'lucide-react'
import { NewsletterSignupWidget } from '../components/NewsletterSignupWidget'
import { SlotImage } from '@/features/designer/components/SlotImage'

const socialLinks = [
  {
    href: 'https://www.instagram.com/onedaydance/',
    label: 'Instagram',
    handle: '@onedaydance',
    Icon: Instagram,
  },
  {
    href: 'https://www.youtube.com/channel/UCNIdQBvGM_Z9Pbe-CNRp5Mw',
    label: 'YouTube',
    handle: 'One Day Dance',
    Icon: Youtube,
  },
  {
    href: 'https://www.facebook.com/OneDayDanceGroup/',
    label: 'Facebook',
    handle: 'OneDayDanceGroup',
    Icon: Facebook,
  },
]

export function ConnectPage() {
  return (
    <div className="relative">
      {/* Background slot image — fills the page region without dictating height */}
      <SlotImage
        slotKey="connect-background"
        className="absolute inset-0 w-full h-full z-0"
        alt=""
        fallback={null}
      />

      <div className="relative z-10 container mx-auto max-w-3xl px-4 py-16">
      <div className="mb-10 text-center">
        <h1 className="mb-3 text-4xl font-bold tracking-tight">Stay in the Loop</h1>
        <p className="text-muted-foreground">
          Get festival updates, open calls, and behind-the-scenes news from One Day Dance.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <section className="rounded-lg border bg-card p-6">
          <h2 className="mb-1 text-lg font-semibold">Join the mailing list</h2>
          <p className="mb-4 text-sm text-muted-foreground">
            Announcements straight to your inbox.
          </p>
          <NewsletterSignupWidget />
        </section>

        <section className="rounded-lg border bg-card p-6">
          <h2 className="mb-1 text-lg font-semibold">Follow along</h2>
          <p className="mb-4 text-sm text-muted-foreground">
            Catch films, festival recaps, and daily updates on social.
          </p>
          <ul className="space-y-3">
            {socialLinks.map(({ href, label, handle, Icon }) => (
              <li key={label}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  <Icon className="h-5 w-5" />
                  <span className="font-medium text-foreground">{label}</span>
                  <span>{handle}</span>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </div>
      </div>
    </div>
  )
}
